import React from 'react'
import injectStyles from 'react-jss'
import { Col, Grid, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import UserDocumentsTable from '../../../../../../Components/UserDocumentsTable'
import { styles } from './styles'
import GenericFlatButton from '../../../../../../Components/GenericFlatButton'

const IdentificationFilesSection = ({
  ambassador,
  documents,
  setDocuments,
  updateUserDocument,
  nmbrsDocument,
  setNmbrsDocument,
  setGermanyContract,
  setGermanyPayroll,
  user,
  classes,
}) => {
  const history = useHistory()

  return (
    <AmbassadorSection>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <div className={classes.headerContainer}>
              <div className={classes.title}>Identification Files</div>
              <GenericFlatButton
                type={'outline'}
                title={'Detailed view'}
                onClick={() =>
                  history.push(history.location.pathname + '/upload-documents')
                }
              />
            </div>
          </Col>
        </Row>

        <Row>
          <UserDocumentsTable
            documents={documents}
            updateUserDocument={updateUserDocument}
            ambassador={ambassador}
            isBa={true}
            setDocuments={setDocuments}
            nmbrsDocument={nmbrsDocument}
            setNmbrsDocument={setNmbrsDocument}
            setGermanyContract={setGermanyContract}
            setGermanyPayroll={setGermanyPayroll}
            user={user}
          />
        </Row>
      </Grid>
    </AmbassadorSection>
  )
}

export default injectStyles(styles)(IdentificationFilesSection)
